export const MODULE_KEY = 'tryOn';

export const STEPS = {
    INITIAL: 'STEP_INITIAL',
    ADJUSTMENT: 'STEP_ADJUSTMENT',
    RESULT: 'STEP_RESULT',
};

export const IMAGE_WIDTH = 284;
export const IMAGE_HEIGHT = 366;
export const CROPPER_HEIGHT = 310;
